/**
 * Copia um texto para a área de transferência. Usa a Clipboard API quando o
 * navegador permite (contexto seguro) e cai no execCommand nos demais.
 */
export async function copyText(text: string): Promise<boolean> {
    const value = String(text || '')

    if (!value) {
        return false
    }

    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(value)
            return true
        }
    } catch (e) {
        // segue para o caminho antigo
    }

    const textarea = document.createElement('textarea')
    textarea.value = value
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()

    try {
        return document.execCommand('copy')
    } catch (e) {
        return false
    } finally {
        document.body.removeChild(textarea)
    }
}
